import React from "react";
import { node, number, oneOf, string } from "prop-types";
import isEmpty from "lodash/isEmpty";
import CustomData from "pages/_components/CustomData/CustomData";

export const TransactionInfo = ({ field, fieldString, i18nId, value, children, className }) => {
    if (!value && !i18nId && isEmpty(children)) {
        return null;
    }

    return (
        <CustomData
            dataClass={className}
            titleText={fieldString || field}
            titleTextType={fieldString ? "TEXT" : "I18N"}
            valueText={i18nId || value || children}
            valueTextType={i18nId ? "I18N" : "TEXT"}
        />
    );
};

TransactionInfo.propTypes = {
    field: string.isRequired,
    fieldString: string,
    i18nId: string,
    value: oneOf([string, number]),
    children: node,
    className: string,
};

TransactionInfo.defaultProps = {
    fieldString: null,
    i18nId: "",
    value: "",
    children: null,
    className: "",
};
export default TransactionInfo;
